import type { FunctionComponent } from 'react';

import { Helmet } from 'components';
import HomeContent from './Content';
import HomeProvider from './context';
import HomeLayout from './Layout';

const Home: FunctionComponent = function () {
  return (
    <HomeProvider>
      <Helmet title="Home" />
      <HomeLayout>
        <HomeContent />
      </HomeLayout>
    </HomeProvider>
  );
};

export default Home;
